export default __webpack_public_path__ + "static/media/cancelled-icon.9b009300.svg";